import { render, staticRenderFns } from "./MessageTemplatesActivity.vue?vue&type=template&id=6df4c0e9&scoped=true&"
import script from "./MessageTemplatesActivity.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesActivity.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplatesActivity.vue?vue&type=style&index=0&id=6df4c0e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4c0e9",
  null
  
)

export default component.exports